<template>
  <!-- prettier-ignore -->
  <ovp-form
    class="entryForm"
    name="entry_widget"
    :validator="$v.form"
    tracking-disabled
    @submit="submit">
    <ovp-zip-chooser
      v-model="form.location"
      class="entryForm-location"
      name="entry.location"
      required
      :contract-start-date="contractStartDate"
      :hint="$t('location.placeholder')"
      :readonly="preFilled"
      :title="$t('person.plz')"
      :theme="theme"
      :validate="$v.form.location"
    />

    <ovp-date-input
      v-model="form.dateOfBirth"
      class="entryForm-dateOfBirth"
      name="entry.dateOfBirth"
      :readonly="preFilled"
      :theme="theme"
      :title="$t('person.birthdate')"
      :validate="$v.form.dateOfBirth"
    />

    <ovp-gender
      v-model="form.gender"
      class="entryForm-gender"
      :age="age"
      :readonly="preFilled"
      :validate="$v.form.gender"
    />

    <ovp-button
      primary
      type="submit">
      {{ buttonText ? buttonText : $t('entry.button') }}
    </ovp-button>
  </ovp-form>
</template>

<script>
import validations from '@/validations/entryWidget'
import { DateTimeHelper } from '@/helpers'

export default {
  name: 'EntryForm',

  props: {
    buttonText: {
      type: String,
      default: '',
    },

    theme: {
      type: String,
      default: 'dark',
    },

    value: {
      type: Object,
      default: () => {},
    },

    contractStartDate: {
      type: String,
      default: '2021-01-01',
    },
  },

  data() {
    return {
      form: {
        dateOfBirth: null,
        gender: null,
        location: {},
        personId: null,
      },
      preFilled: false,
    }
  },

  validations,

  watch: {
    value(value) {
      this.preFilled = false

      if (Object.keys(this.value).length === 4) {
        this.preFilled = true
      }

      this.form = {
        dateOfBirth: value.dateOfBirth ?? null,
        gender: value.gender ?? null,
        location: value.location ?? {},
        personId: value.personId,
      }
    },

    'form.dateOfBirth'() {
      if (this.isUnborn) {
        this.form.gender = 'UNBORN'
      } else if (this.form.gender === 'UNBORN') {
        this.form.gender = null
        this.$v.form.gender.$reset()
      }
    },
  },

  computed: {
    age() {
      return DateTimeHelper.getAge(this.form.dateOfBirth)
    },

    classes() {
      return {
        entry: true,
        [`entry--${this.theme}`]: true,
      }
    },
  },

  methods: {
    submit() {
      this.$v.$touch()

      if (!this.$v.$invalid) {
        this.$emit('submit', this.form)
      }
    },
  },
}
</script>

<style name="mobile" scoped>
.entryForm {
  display: grid;
  grid-gap: 20px;
  grid-template-areas:
    'location location'
    'dateOfBirth gender'
    'button button';
  grid-template-columns: 150px 1fr;

  &-location {
    grid-area: location;
  }

  &-dateOfBirth {
    grid-area: dateOfBirth;
  }

  &-gender {
    grid-area: gender;
    margin: 0 20px 0 0;
    min-width: auto;

    & >>> .gender-element {
      display: grid;
      color: var(--c-white);

      .gender-item__text {
        display: none;
      }

      .gender-item {
        color: var(--c-white);

        &--selected {
          color: var(--c-original-green);
        }
      }
    }
  }

  .button {
    grid-area: button;
  }
}
</style>

<style name="desktop" scoped>
@media (--md) {
  .entryForm {
    grid-template-areas: 'location dateOfBirth gender button';
    grid-template-columns: 280px 150px minmax(130px, auto) 1fr;

    &-gender {
      & >>> .gender-element {
        justify-content: flex-start;

        .gender-item__text {
          display: initial;
        }
      }
    }
  }
}
</style>
